import type { ClassificationConfig } from './config';

export function updateCategoryPresentation(
  config: ClassificationConfig,
  value: string,
  patch: Readonly<{ label?: string; color?: string }>,
): ClassificationConfig {
  return {
    ...config,
    categories: config.categories.map((category) => category.value !== value ? category : {
      ...category,
      ...(patch.label !== undefined ? { label: patch.label.trim() || category.value } : {}),
      ...(patch.color && /^#[0-9a-f]{6}$/i.test(patch.color) ? { color: patch.color.toLowerCase() } : {}),
    }),
  };
}

export function updateRemainderPresentation(
  config: ClassificationConfig,
  patch: Readonly<{ label?: string; color?: string }>,
): ClassificationConfig {
  return {
    ...config,
    ...(patch.color && /^#[0-9a-f]{6}$/i.test(patch.color) ? { remainderColor: patch.color.toLowerCase() } : {}),
    legend: {
      ...config.legend,
      ...(patch.label !== undefined ? { remainderLabel: patch.label.trim() || 'Resto visible' } : {}),
    },
  };
}

/**
 * Colour or alias of one secondary (outline) category. A category shown with a fallback colour (new since the
 * categories were built) is stored on its first edit; the source value is never changed.
 */
export function updateSecondaryCategoryPresentation(
  config: ClassificationConfig,
  value: string,
  patch: Readonly<{ label?: string; color?: string }>,
  fallback: Readonly<{ label: string; color: string }>,
): ClassificationConfig {
  const secondary = config.secondary; if (!secondary) return config;
  const current = secondary.categories.find((category) => category.value === value) ?? { value, label: fallback.label, color: fallback.color, visible: true };
  const next = {
    ...current,
    ...(patch.label !== undefined ? { label: patch.label.trim() || value } : {}),
    ...(patch.color && /^#[0-9a-f]{6}$/i.test(patch.color) ? { color: patch.color.toLowerCase() } : {}),
  };
  const categories = secondary.categories.some((category) => category.value === value)
    ? secondary.categories.map((category) => category.value === value ? next : category)
    : [...secondary.categories, next];
  return { ...config, secondary: { ...secondary, categories } };
}
